export enum RotationOptionEnum {
  flipHorizontal = 'flipHorizontal',
  flipVertical = 'flipVertical',
  rotateRight = 'rotateRight',
  rotateLeft = 'rotateLeft',
}
